import { render, staticRenderFns } from "./coupon-view.vue?vue&type=template&id=c95d6628&scoped=true&"
import script from "./coupon-view.vue?vue&type=script&lang=js&"
export * from "./coupon-view.vue?vue&type=script&lang=js&"
import style0 from "./coupon-view.vue?vue&type=style&index=0&id=c95d6628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d6628",
  null
  
)

export default component.exports